// @flow

import React, { type Node } from 'react';
import { useSubmitting } from '@tectonics/prs/submitting';
import { Label, Select, Option } from '../../../../../../commons/atoms';
import { InputGroup } from '../../../../../../commons/molecules';
import { useUserInputAsSelect } from '@tectonics/prs/user-input-values';
import { BRAZILIAN_STATES } from '@tectonics/prs/brazil';

export function InputBrazilianState(): Node {
  const [value, handleChange] = useUserInputAsSelect('brazilianState');
  const submitting = useSubmitting();

  return (
    <div data-test-name="address-state">
      <InputGroup
        label={<Label>Estado</Label>}
        input={
          <Select value={value} onChange={handleChange} readOnly={submitting} name="address-state">
            <Option value="">Selecione seu estado</Option>

            {BRAZILIAN_STATES.map(brazilianState => (
              <Option key={brazilianState.code} value={brazilianState.code}>
                {brazilianState.name}
              </Option>
            ))}
          </Select>
        }
      />
    </div>
  );
}
